import React from 'react';
import Styled from 'styled-components/macro';
import BugTaskInputIconPath from '../../../../../../images/ico-bug';
import NonBillableTaskInputIconPath from '../../../../../../images/ico-nonbillable';
import PriorityTaskInputIconPath from '../../../../../../images/ico-priority';
import BlockedTaskInputIconPath from '../../../../../../images/ico-blocked';
import {useIntl} from 'react-intl';
import {isFeatureHidden} from '../../../../../shared/util/CompanySetupUtil';
import {HIDDEN_FEATURES} from '../../../../../../constants';

export const TaskIndicatorsColumn = ({task}) => {
	const {formatMessage} = useIntl();
	const iconColor = '#535353';

	return (
		<IndicatorsContainer>
			{task.indicators.priority && (
				<IndicatorIcon>
					<PriorityTaskInputIconPath
						cy="icon-priority"
						title={formatMessage({id: 'common.high_priority'})}
						active={false}
						fill={iconColor}
					/>
				</IndicatorIcon>
			)}
			{task.indicators.bug && (
				<IndicatorIcon>
					<BugTaskInputIconPath
						cy="icon-bug"
						title={formatMessage({id: 'common.bug'})}
						active={false}
						className="active-state"
						fill={iconColor}
					/>
				</IndicatorIcon>
			)}
			{!task.indicators.billable && !isFeatureHidden(HIDDEN_FEATURES.REVENUE) && (
				<IndicatorIcon>
					<NonBillableTaskInputIconPath
						cy="icon-nonbillable"
						title={formatMessage({id: 'common.non-billable'})}
						active={true}
						className="active-state"
						fill={iconColor}
					/>
				</IndicatorIcon>
			)}
			{task.indicators.blocked && (
				<IndicatorIcon>
					<BlockedTaskInputIconPath
						cy="icon-blocked"
						title={formatMessage({id: 'common.blocked'})}
						active={false}
						fill={iconColor}
					/>
				</IndicatorIcon>
			)}
		</IndicatorsContainer>
	);
};

export const IndicatorsContainer = Styled.div`
	display: inline;
    display:flex;
    padding-left: 16px;
    padding-right: 16px;
`;

export const IndicatorIcon = Styled.span`
	display:inline;
	margin: 0 4px;
	display:flex;
`;
